import type { CharacterProfile } from '../types';

export function BiographyPanel({ character }: { character: CharacterProfile }) {
  return (
    <section className="biography" aria-labelledby="bio-heading">
      <h2 id="bio-heading">Dossier</h2>
      <p>{character.biography}</p>
      <dl className="bio-facts">
        {character.arena && <div><dt>Island arena</dt><dd>{character.arena}</dd></div>}
        <div><dt>Origin</dt><dd>{character.origin}</dd></div>
        <div><dt>Affiliation</dt><dd>{character.affiliation}</dd></div>
        <div><dt>Specialty</dt><dd>{character.fightingStyle}</dd></div>
        <div><dt>Signature move</dt><dd>{character.signatureMove}</dd></div>
        <div><dt>Strengths</dt><dd>{character.strengths.join(' / ')}</dd></div>
        <div><dt>Weaknesses</dt><dd>{character.weaknesses.join(' / ')}</dd></div>
        <div><dt>Rivalries</dt><dd>{character.rivalries.join(' / ')}</dd></div>
        <div><dt>Disposition</dt><dd>{character.traits.join(' / ')}</dd></div>
      </dl>
    </section>
  );
}
